import { render, staticRenderFns } from "./business_info.vue?vue&type=template&id=3a43ba8b&scoped=true&"
import script from "./business_info.vue?vue&type=script&lang=ts&"
export * from "./business_info.vue?vue&type=script&lang=ts&"
import style0 from "./business_info.vue?vue&type=style&index=0&id=3a43ba8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a43ba8b",
  null
  
)

export default component.exports